import { cloneDeep } from '../../utils/miscellaneous/objectHelpers';
import { dataActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    mockData: true,
    taxHousehold: {
        bloodRelationship: [],
        householdMember: []
    }
};


export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case dataActionTypes.SET_SESSION_INITIAL_DATA:
            return cloneDeep(action.data);
        case dataActionTypes.UPDATE_SSNS:
            return {
                ...state,
                taxHousehold: {
                    ...state.taxHousehold,
                    householdMember: state.taxHousehold.householdMember.map(hhm => {
                        const {
                            applicantGuid
                        } = hhm;

                        const matchedSSN = action.ssns.find(ssn => ssn.applicantGuid === applicantGuid);

                        if(!matchedSSN) {
                            console.error(`Session data snapshot: SSN for applicant with GUID ${applicantGuid} is not found amid received SSNs`);
                            return hhm;
                        } else {
                            return {
                                ...hhm,
                                socialSecurityCard: {
                                    ...hhm.socialSecurityCard,
                                    socialSecurityNumber: matchedSSN.ssn
                                }
                            };
                        }
                    })
                }
            };
        case dataActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};